import React from "react";
import {
    Container,
} from "react-bootstrap";
import ReactGA from 'react-ga';
export default function AboutUs (){
    ReactGA.pageview(window.location.pathname + window.location.search);    
    return (

        <Container className='mt-5 mb-5'>
          <h2>About Us</h2>
          <h5>As an online dentist-patient communication platform that allows patients to manage their oral health, and dentists to market their services, Denteractive provides patients with access to pre-screened high quality certified dentists online. Denteractive enables patients to easily search, access and communicate, in real time with local or national dentists or dental specialists for the purposes of consultation, introductory meetings, appointment making, and information and/or pertinent files sharing to meet their immediate dental needs including dental emergencies.</h5>
        </Container>
    )
}


